import * as React from "react";
import { Dropdown, DropdownProps } from "semantic-ui-react";

export type DropdownFieldProps = {
  id: string;
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
  value: boolean | number | string | (boolean | number | string)[] | undefined;
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
};

export type DropdownFieldState = {
  value: boolean | number | string | (boolean | number | string)[] | undefined;
};

class MultipleSelection extends React.Component<DropdownFieldProps, DropdownFieldState> {
  constructor(props: DropdownFieldProps) {
    super(props);
    this.state = {
      value: this.props.value
    };
  }

  render(): JSX.Element {
    const { label, options, disabled = false, onChange, id } = this.props;
    return (
      <div>
        <label className="multi-selection-label">{label}</label>
        <Dropdown
          id={id}
          value={this.state.value || []}
          clearable={true}
          fluid
          multiple
          search
          selection
          disabled={disabled}
          options={options}
          onChange={(event: React.SyntheticEvent, data: DropdownProps) => {
            this.setState({ value: data.value });
            onChange(data.value);
          }}
        />
      </div>
    );
  }
}
export default MultipleSelection;
